// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceVirus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.432 3.868c.498-2.49 3.912-2.49 4.41 0l.192.963a.502.502 0 0 0 .774.334l.79-.54c2.043-1.394 4.457 1.121 3.118 3.249l-.517.823c-.196.31-.03.73.32.806l.925.2c2.39.519 2.39 4.075 0 4.594l-.925.2c-.35.076-.516.495-.32.806l.517.823c1.34 2.128-1.075 4.643-3.118 3.248l-.79-.539a.502.502 0 0 0-.773.334l-.193.963c-.498 2.49-3.912 2.49-4.41 0l-.192-.963a.502.502 0 0 0-.774-.334l-.79.54c-2.043 1.394-4.457-1.121-3.118-3.249l.517-.823c.196-.31.03-.73-.32-.806l-.925-.2c-2.39-.519-2.39-4.075 0-4.594l.925-.2c.35-.076.516-.495.32-.806l-.517-.823C3.219 5.746 5.633 3.23 7.676 4.626l.79.539c.299.204.7.03.774-.334zm2.701.37a.503.503 0 0 0-.992 0l-.192.963c-.324 1.62-2.112 2.391-3.44 1.485l-.79-.54c-.46-.313-1.003.252-.701.731l.517.823c.87 1.383.13 3.246-1.424 3.583l-.925.2c-.538.117-.538.917 0 1.034l.925.2c1.554.337 2.295 2.2 1.424 3.583l-.517.823c-.302.479.242 1.044.701.73l.79-.539c1.328-.906 3.116-.135 3.44 1.484l.192.963c.112.56.88.56.992 0l.193-.963c.323-1.619 2.111-2.39 3.44-1.484l.789.54c.46.313 1.003-.253.702-.731l-.518-.823c-.87-1.383-.13-3.246 1.425-3.583l.924-.2c.538-.117.538-.917 0-1.034l-.924-.2c-1.555-.337-2.296-2.2-1.425-3.583l.518-.823c.3-.479-.243-1.044-.702-.73l-.79.539c-1.328.906-3.116.135-3.44-1.485zM8.757 14c0-.552.43-1 .96-1s.96.448.96 1-.43 1-.96 1-.96-.448-.96-1zm6.72-3.5c0 1.38-1.074 2.5-2.4 2.5-1.325 0-2.4-1.12-2.4-2.5s1.075-2.5 2.4-2.5c1.326 0 2.4 1.12 2.4 2.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceVirus;
